/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AutoSyncCounts } from './autoSyncCounts';

export interface SingleCandidateActionResponse {
  job_candidate_id: string;
  target_stage_id: string;
  target_stage_name: string;
  auto_sync?: AutoSyncCounts | null;
}
